import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ButtonCard from '@narvar/nth-button-card';
import TextLink from '@narvar/nth-text-link';
import MailIcon from '@narvar/nth-mail-icon';
import CarrierLogo from '../CarrierLogo';
import ReturnCardContainer from '../ReturnCardContainer';
import { a11ySelection } from '../../lib/a11yUtils';

export const mapStateToProps = (
  {
    language = {},
    retailerSettings: {
      branding: {
        link_color: linkColor,
        link_hover_color: linkHoverColor,
        brand_call_to_action: brandCTAColor,
      } = {},
    } = {},
  } = {},
  { optionId, methodKey },
) => ({
  linkColor,
  linkHoverColor,
  brandCTAColor,
  title: language[`returns.return_options.${optionId}.${methodKey}.title`],
  description: language[`returns.return_options.${optionId}.${methodKey}.description`],
  storeLinkURL: language[`returns.return_options.${optionId}.${methodKey}.store_link`],
  storeLinkText: language[`returns.return_options.${optionId}.${methodKey}.store_link_text`],
});

const ReturnMethodCard = ({
  carrier,
  onClick,
  singleCard,
  selected,
  linkColor,
  linkHoverColor,
  brandCTAColor,
  title,
  fee,
  description,
  storeLinkURL,
  storeLinkText,
  optionWidth,
  methodKey,
}) => (
  <ReturnCardContainer
    s={{
      width: optionWidth,
      minHeight: '200px',
      hoverBorderColor: brandCTAColor,
      hoverBorderWidth: selected ? '3px' : '1px',
      borderWidth: selected ? '3px' : '1px',
      borderColor: selected ? `${brandCTAColor}` : '#ccc',
      ...(singleCard && {
        hoverBorderStyle: 'none',
        hoverBackground: 'transparent',
        borderStyle: 'none',
        background: 'transparent',
        paddingTop: '0px',
        paddingBottom: '0px',
      }),
    }}
    onClick={a11ySelection(onClick)}
    onKeyDown={a11ySelection(onClick)}
    tabIndex="0"
    data-test={`return-method-card-${methodKey}`}
    role="button"
  >
    <ButtonCard
      layout="column"
      icon={
        methodKey === 'self' ? (
          <MailIcon s={{ width: '5rem' }} />
        ) : (
          <div
            style={{
              height: '5rem',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CarrierLogo carrier={carrier} />
          </div>
        )
      }
      s={{
        borderStyle: 'none',
        paddingTop: selected ? 'calc(1.5rem - 2px)' : '1.5rem',
        paddingBottom: selected ? 'calc(1.5rem - 2px)' : '1.5rem',
        paddingLeft: selected ? 'calc(1rem - 2px)' : '1rem',
        paddingRight: selected ? 'calc(1rem - 2px)' : '1rem',
        hoverBorderStyle: 'none',
        hoverBackground: 'transparent',
        background: 'transparent',
      }}
    >
      <ButtonCard.BigHeader
        s={{
          fontWeight: 'bold',
          fontSize: '1.25rem',
          lineHeight: '1.25rem',
          ...(title && {
            margin: '1rem auto 2rem auto',
          }),
        }}
      >
        {title}
      </ButtonCard.BigHeader>
      <ButtonCard.SmallHeader>{fee}</ButtonCard.SmallHeader>
      <ButtonCard.Paragraph s={{ fontSize: '0.9rem' }}>{description}</ButtonCard.Paragraph>
      <TextLink
        target="_blank"
        href={storeLinkURL}
        s={{ color: linkColor, hoverColor: linkHoverColor, textDecoration: 'underline' }}
      >
        {storeLinkText}
      </TextLink>
    </ButtonCard>
  </ReturnCardContainer>
);

ReturnMethodCard.defaultProps = {
  linkColor: '#2b7cac',
  linkHoverColor: '#2b7cac',
  brandCTAColor: '#000000',
  title: '',
  fee: '',
  description: '',
  carrier: '',
  singleCard: false,
  storeLinkURL: '',
  storeLinkText: '',
  optionWidth: '100%',
  methodKey: '',
};

ReturnMethodCard.propTypes = {
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  linkColor: PropTypes.string,
  linkHoverColor: PropTypes.string,
  brandCTAColor: PropTypes.string,
  title: PropTypes.string,
  carrier: PropTypes.string,
  fee: PropTypes.string,
  singleCard: PropTypes.bool,
  description: PropTypes.string,
  storeLinkURL: PropTypes.string,
  storeLinkText: PropTypes.string,
  optionWidth: PropTypes.string,
  methodKey: PropTypes.string,
};

export default connect(mapStateToProps)(ReturnMethodCard);
